import {
  normalizeForCampaignSearch,
  parseCampaignSearchTokens,
} from '@/utils/campaignSearch';

/** Flatten cell/display values into one searchable string. */
export function valuesToSearchHaystack(values: unknown[]): string {
  return values
    .filter((value) => value != null)
    .map((value) => {
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    })
    .join(' ');
}

/** Every token must appear in the normalized haystack (substring, order-independent). */
export function matchesTableSearch(values: unknown[], rawQuery: string): boolean {
  const tokens = parseCampaignSearchTokens(rawQuery);
  if (tokens.length === 0) return true;
  const haystack = normalizeForCampaignSearch(valuesToSearchHaystack(values));
  return tokens.every((token) => haystack.includes(token));
}

export function filterRowsByTableSearch<T>(
  rows: T[],
  rawQuery: string,
  getSearchValues: (row: T) => unknown[]
): T[] {
  const tokens = parseCampaignSearchTokens(rawQuery);
  if (tokens.length === 0) return rows;
  return rows.filter((row) => matchesTableSearch(getSearchValues(row), rawQuery));
}
